export default __webpack_public_path__ + "static/custom-watermark-invoice-3b5031e312ea91234749ebbd5a30a32d.png";